<template>
  <button
    type="button"
    @click="action"
    :class="{ selected: selected }"
    :disabled="disabled"
    class="button"
  >
    {{ label }}
  </button>
</template>

<style scoped>
  .button {
    height: 3rem;
    box-sizing: border-box;
    padding: 5px;
    font-family: inherit;
    font-size: 1.3rem;
    color: inherit;
    background-color: var(--secondary-background-color);
    border: 2px solid transparent;
    border-radius: 13px;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
    outline: none;
    cursor: pointer;
    transition-property: border-color, box-shadow;
    transition-duration: 0.3s;
  }

  .button:hover {
    border-color: var(--secondary-color);
  }

  .button.selected {
    border-color: var(--primary-color);
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1), inset 0 0 2px var(--secondary-color);
  }

  .button:disabled {
    cursor: auto;
  }
</style>

<script>
  export default {
    props: [
      'label',
      'disabled',
      'selected',
      'action'
    ]
  }
</script>
